import { useEffect, useState } from "react";
import { BACKOFFICE_API } from "../../../core/apis/backoffice-apis";
import { FRONTOFFICE_API } from "../../../core/apis/frontoffice-apis";
import { SERVICES } from "../../../core/services/services";
import { UserTypes } from "../../constants";
import { HELPER } from "../../helper/helper";
import { DetailsBreakDown } from "../details-break-down/details-break-down";

export function TokenDetailsByReference(props) {
  const [loading, setLoading] = useState(false);
  const [tokenDetails, setTokenDetails] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    function getTokenByReference() {
      setLoading(true);
      const backofficeUrl = BACKOFFICE_API.DEBIT_MANDATES;
      const frontofficeUrl = FRONTOFFICE_API.DEBIT_MANDATES;
      const url =
        props.userType === UserTypes.Frontoffice
          ? frontofficeUrl
          : backofficeUrl;
      SERVICES.MAKE_GET_REQUEST(`${url}/token/${props.tokenReference}`)
        .then((data) => {
          setTokenDetails(HELPER.GET_DETAILS_ARRAY(data?.result));
          setLoading(false);
          console.log(data, "data");
        })
        .catch((error) => {
          console.log("error", error);
          setError(HELPER.PROCESS_ERROR(error));
          setLoading(false);
        });
    }
    getTokenByReference();
  }, [props.tokenReference, props.userType]);

  return (
    <DetailsBreakDown
      error={error}
      loading={loading}
      breakDown={tokenDetails}
      title="Token"
      closeModal={props.closeModal}
    />
  );
}
